import React, { useState } from 'react';
import { styled, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import LibraryAddCheckTwoToneIcon from '@mui/icons-material/LibraryAddCheckTwoTone';
import ThumbsUpDownTwoToneIcon from '@mui/icons-material/ThumbsUpDownTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { Element } from '@fulcrumapp/fulcrum-core';

interface Props {
  element: Element,
  elementCount: number,
  onChangeLabel: (key: string, value: string) => void,
  onDelete: (key: string) => void,
  onChangeType: (type: string, key: string) => void,
  onPressEnter: () => void
}

const DeleteButton = styled(IconButton)({
  alignSelf: 'center',
  '&.Mui-disabled': {
    visibility: 'hidden',
  },
});

const theme = createTheme();

const fieldTypeIcons = {
  CheckboxField: <LibraryAddCheckTwoToneIcon fontSize="small" />,
  YesNoField: <ThumbsUpDownTwoToneIcon fontSize="small" />,
};

const ChecklistEditorItem = ({
  element,
  elementCount,
  onChangeLabel,
  onDelete,
  onChangeType,
  onPressEnter,
}: Props) => {
  const [fieldValue, setFieldValue] = useState(element.label);
  const [fieldType, setFieldType] = useState(element.type);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.value);
    onChangeLabel(element.key, e.target.value);
  };

  const handleDeleteField = () => {
    onDelete(element.key);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !!fieldValue.length) {
      e.preventDefault();
      onPressEnter();
    }
  };

  const handleTypeChange = () => {
    // TODO Add back and finish once we add yes no fields
    // setFieldType(fieldType === 'CheckboxField' ? 'YesNoField': 'CheckboxField');
    // onChangeType(element.key, fieldType);
    // setFieldValue('');
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      paddingBottom={theme.spacing(2)}
    >
      <TextField
        id={element.key}
        sx={{ flexGrow: 1 }}
        label="Item Label"
        variant="outlined"
        placeholder="Item Label"
        value={fieldValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        autoFocus
        // TODO Add back when yes no fields are added
        // InputProps={{
        //   endAdornment: (
        //     <InputAdornment position="end">
        //       <IconButton
        //         aria-label="change checklist item type"
        //         size="medium"
        //         className={classes.changeTypeButton}
        //         onClick={handleTypeChange}
        //       >
        //         {fieldTypeIcons[fieldType]}
        //       </IconButton>
        //     </InputAdornment>
        //   )
        // }}
      />
      <DeleteButton
        aria-label="delete item"
        size="medium"
        onClick={handleDeleteField}
        disabled={elementCount === 1}
      >
        <DeleteTwoToneIcon />
      </DeleteButton>
    </Box>
  );
};

export default ChecklistEditorItem;
